import { Injectable } from "@angular/core";
import { AbstractHealthcareservice, IAccount, IEthnicGroup, Organization } from "@comunicare/comunicare-interfaces";
import { IUserService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable, of } from "rxjs";
import { finalize, map, switchMap, tap } from "rxjs/operators";
import { Healthcareservice } from "../healthcareService/healthcareService.model";
import { SessionService } from "../shared/services/session.service";
import { UserApiService } from "./user.api";

@Injectable({
  providedIn: "root",
})
export class UserService implements IUserService {
  private isGettingAccount = false;

  private pAllOrganizations: Organization[] = [];
  public get allOrganizations(): Organization[] {
    return this.pAllOrganizations;
  }
  public set allOrganizations(value: Organization[]) {
    this.pAllOrganizations = value;
  }
  private pAllServices: AbstractHealthcareservice[] = [];
  public get allServices(): AbstractHealthcareservice[] {
    return this.pAllServices;
  }
  public set allServices(value: AbstractHealthcareservice[]) {
    this.pAllServices = value;
  }
  private pOwnOrganization: Organization;
  public get ownOrganization(): Organization {
    return this.pOwnOrganization;
  }
  public set ownOrganization(value: Organization) {
    this.pOwnOrganization = value;
  }
  private pAllMonitoringServices: AbstractHealthcareservice[] = [];
  public get allMonitoringServices(): AbstractHealthcareservice[] {
    return this.pAllMonitoringServices;
  }
  public set allMonitoringServices(value: AbstractHealthcareservice[]) {
    this.pAllMonitoringServices = value;
  }
  private pAllMonitoringOrganizations: Organization[] = [];
  public get allMonitoringOrganizations(): Organization[] {
    return this.pAllMonitoringOrganizations;
  }
  public set allMonitoringOrganizations(value: Organization[]) {
    this.pAllMonitoringOrganizations = value;
  }

  public isMonitoringUser = false;

  constructor(
    private userApi: UserApiService,
    private sessionService: SessionService
  ) {}

  public clear(): void {
    this.allMonitoringOrganizations = [];
    this.allMonitoringServices = [];
    this.allOrganizations = [];
    this.allServices = [];
    this.ownOrganization = null;
    this.isMonitoringUser = false;
  }

  public search(search: string): Observable<IAccount[]> {
    return this.userApi.search(search);
  }

  public account(): Observable<IAccount> {
    return this.sessionService.getObservableAccount().pipe(
      switchMap((account) => {
        if (account !== undefined || this.isGettingAccount) {
          return of(account);
        } else {
          if (!this.sessionService.token) {
            return of(undefined);
          }

          this.isGettingAccount = true;
          return this.me().pipe(
            tap((acc) => {
              this.sessionService.account = acc;
            }),
            finalize(() => {
              this.isGettingAccount = false;
            })
          );
        }
      })
    );
  }

  public defaultPage(): Observable<string> {
    return of("/dashboard");
  }

  public isAuthorized(_routeName: string, _method: string): Observable<boolean> {
    return of(true);
  }

  public isAuthorizedSync(_account: IAccount, _routeName: string, _method: string): boolean {
    return true;
  }

  private me(): Observable<IAccount> {
    return this.userApi.me() as Observable<IAccount>;
  }

  public updateAccount(account: IAccount): Observable<Record<string, never>> {
    return this.userApi.updateAccount(account);
  }

  public getMyService(): Observable<AbstractHealthcareservice> {
    return this.userApi.getMyService().pipe(
      map((values) => {
        return new Healthcareservice(values);
      })
    );
  }
  public getAllEthnicGroups(): Promise<IEthnicGroup[]> {
    return this.userApi.getAllEthnicGroups().toPromise();
  }
}
